module.exports = __webpack_public_path__ + "img/Light Statistics.c015c063.png";